
function submitForm(){

  $('#customers-feedback-form-11').LoadingOverlay("show");
  var postData = $("#customers-feedback-form-11").serializeArray();   
  postData.push( {name:'action', value:'sendMail'} );
  $.ajax({
    type: 'POST',
    url: 'https://codesdesk.com/apps/phptweaks/chemtech/send_mail.php',
    data: postData,
    dataType: 'json',
    success: function(response){ //console.log(response);
      $('#customers-feedback-form-11').LoadingOverlay("hide");
      if(response.status == 'true' || response.status == true ){ 

        $('#success--alert--10').show();
        $('#customers-feedback-form-11').hide();
      }
    }
  })
}

$(document).ready(function(){

  $("#customers-feedback-form-btn-11").click(function(e){
    var is_error_exists = 'NO';
    $('#customers-feedback-form-11 .customers-feedback-tab').each(function(){
      $(this).find('.quest_ans_error').text('');
      var radioValue = $(this).find('input[type="radio"]');
      var textareaValue = $(this).find('textarea');

      if(radioValue.length > 0 && textareaValue.length > 0 ){

        var is_radio_selected = $(this).find('input[type="radio"]:checked');
        var curr_textarea_val = $.trim(textareaValue.val());

        if(is_radio_selected.length == 0 && curr_textarea_val == ''){
          $(this).find('.quest_ans_error').text('Please choose your answer or enter your reviews');is_error_exists = 'YES';
        }

        var curr_radio_val = $.trim(is_radio_selected.val());

      }

      if(textareaValue.length > 0 && radioValue.length == 0){
        var curr_textarea_val = $.trim(textareaValue.val());
        if(curr_textarea_val == ''){
          $(this).find('.quest_ans_error').text('Please enter your reviews'); is_error_exists = 'YES';
        }

      }

    })

    if(is_error_exists == 'NO'){
      submitForm();
    }
  })




  function manage_quantity_onpage_load(){  
    $('.tab_product_form tbody tr ').each(function(){  
      var mainThis = $(this); 
      var quant = mainThis.find('.product-quantity-block').find('.cdk-quantity-box').find('.prod_quantity').val();
      quant = parseInt(quant); if(quant > 1){   }  else { quant = 1;  }
      mainThis.find('.cdk-addToCart').attr('data-item-quantity',quant);     
    }) 
  }  
  manage_quantity_onpage_load()
  //Ajax Add To Cart Function Start
  function ajaxAddToCart(id, quantity) {
    var dynamicData = "quantity="+quantity+"&id="+id;
    return $.ajax({
      url: "/cart/add.js",
      type: "get",
      data: dynamicData,
      dataType: "json",
      beforeSend: function() {
        //console.log('loading');  
      },
      error: function(jqXHR, textStatus, errorThrown) {
        if(jqXHR.status == 400) { alert(jqXHR.responseJSON.message); }
      }
    });
  }


  //Ajax Cart Count Function Start
  function cartCount(){ $.getJSON('/cart.js', function(cart) { $("header #cart .cart-count").html(cart.item_count);});}
  cartCount();
  //Ajax Cart Count Function End

  // Add To Cart Button Jquery Start
  function manage_addtocart_success_popup(currentThis,responseData){
    var productName = responseData.product_title;       var productQty = currentThis.attr('data-item-quantity');
    var variantOptionName = responseData.variant_title; var variantFeaturedImage = responseData.image;
    var price = responseData.price;
    var totlaprice= responseData.line_price;
    var variantPrice = '<span class="money">'+Shopify.formatMoney(price)+'</span>' ;  
    var variantTitle = responseData.variant_title;  var variantTitleHtml = '';
    if(variantTitle != '' && variantTitle != null){

      for(var i=0;i<responseData.options_with_values.length;i++){
        var optionName = responseData.options_with_values[i].name;var optionValue = responseData.options_with_values[i].value;
        variantTitleHtml +='<p class="options">'+optionName+': <span class="cdk-p-options ">'+optionValue+'</span></p>';
      }         
    }
    console.log('productName :: '+productName);
    $('.addtocart--success-popup--modal .cdk-model-content .content--block .image-block img').attr('src',variantFeaturedImage);
    $('.addtocart--success-popup--modal .cdk-model-content .content--block .detail-block .cdk-modal-title').html(productName);
    $('.addtocart--success-popup--modal .cdk-model-content .content--block .detail-block .cdk-product-price').html(variantPrice);
    $('.addtocart--success-popup--modal .cdk-model-content .content--block .detail-block .product--choose-option-block').html(variantTitleHtml);
    $('.addtocart--success-popup--modal .cdk-model-content .content--block .detail-block .cdk-p-quantity').html(productQty);
  }
  $(document).on("click", ".cdk-addToCart", function(p) {
    p.preventDefault(); var currentThis = $(this);
    var quantity = parseInt($(this).attr('data-item-quantity')),
        id = $(this).attr('data-varient-id');
    ajaxAddToCart(id, quantity).done(function(data) {
      console.log(JSON.stringify(data));
      var responseData = data;
      $('.cdk-modal-overlayer, .act-success-modal').addClass('active');
      manage_addtocart_success_popup(currentThis,responseData);   
      cartCount();
    });
  });

  // Add To Cart Button Jquery End

  $('body').on('click', '.cdk-modal-overlayer.active, .cdk-model-body .modal-close', function(){
    $('.cdk-modal-overlayer').removeClass('active');
    $('.cdk-model-body').removeClass('active');
  })

  $(document).on("click", ".product-quantity-block .cdk-quantity-box .cdk-q-btnleft .decrease--quantity", function(){
    var quant = $(this).parents('.cdk-quantity-box').find('.cdk-q-input').find('.prod_quantity').val();
    quant = parseInt(quant);    
    if(quant > 1){  quant = quant-1; }  else { quant = 1;  }
    $(this).parents('.cdk-quantity-box').find('.cdk-q-input').find('.prod_quantity').val(quant);
    $(this).parents('.tab_product_form ').find('.cdk-addToCart').attr('data-item-quantity',quant); 
  })  
  $(document).on("click", ".product-quantity-block .cdk-quantity-box .cdk-q-btnright .increase--quantity", function(){
    var quant = $(this).parents('.cdk-quantity-box').find('.cdk-q-input').find('.prod_quantity').val();
    quant = parseInt(quant); 
    if(quant >= 1){  quant = quant+1; } else { quant = 1;  }  
    $(this).parents('.cdk-quantity-box').find('.cdk-q-input').find('.prod_quantity').val(quant);
    $(this).parents('.tab_product_form ').find('.cdk-addToCart').attr('data-item-quantity',quant); 
  })

  $(document).on("click", ".cdk-quantity-box .cdk-q-btnleft .c_decrease--quantity", function(){
    var quant = $(this).parents('.cdk-quantity-box').find('.cdk-q-input').find('.cart_quantity').val();
    quant = parseInt(quant); 
    console.log('quant'+quant);
    if(quant > 1){  quant = quant-1; }  else { quant = 0;  }
    $(this).parents('.cdk-quantity-box').find('.cdk-q-input').find('.cart_quantity').val(quant);
    $( "input[name='update']" ).trigger( "click" );
  })  
  $(document).on("click", ".cdk-quantity-box .cdk-q-btnright .c_increase--quantity", function(){
    var quant = $(this).parents('.cdk-quantity-box').find('.cdk-q-input').find('.cart_quantity').val(); 
    quant = parseInt(quant); 
    console.log('quant'+quant);
    if(quant >= 1){  quant = quant+1; } else { quant = 1;  }
    $(this).parents('.cdk-quantity-box').find('.cdk-q-input').find('.cart_quantity').val(quant);
    $( "input[name='update']" ).trigger( "click" );
  })
$(document).on("click", "#filter_height", function(){
   $(this).toggleClass('See More');
  if($(this).hasClass('SeeMore')){
        $(this).text('See More');         
    } else {
        $(this).text('See Less');
    }
   $(this).parents('.filter').find('.short_filter_list li').toggleClass('show');
   // $(this).parents('.filter').find('.filter_full_list').toggleClass('show'); 
  });
});
